<template>
  <div>
    <es-loader
      v-if="loading"
      style="margin: 1rem"
    />
    <es-exception
      v-else-if="loadingError"
      exceptionMessage="Transaction not found."
    />
    <div v-else>
      <div>
        <es-profile-header>
          <template #profile-header>
            <div class="columns">
              <div class="column">
                <div class="column-content">
                  <div class="header-title">
                    Transaction Profile
                  </div>
                  <div class="header-subtitle">
                    Contains one record.
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template #profile-overview>
            <div class="columns">
              <div class="column">
                <div class="column-content">
                  <div class="column-title">
                    {{ transaction.pidSubmissionId }}
                  </div>
                  <div class="column-subtitle">
                    Transaction ID
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="column-content">
                  <div class="column-title">
                    <div>
                      {{ transaction.pidBatch.submissionTypeCode }}
                    </div>
                    <div
                      v-if="transaction.pidBatch.submissionTypeCode === 'FILE'"
                      class="max-width" style="margin: auto"
                    >
                      ({{ transaction.pidBatch.fileName }})
                    </div>
                  </div>
                  <div class="column-subtitle">
                    Submission Type
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="column-content">
                  <div class="column-title">
                    {{ formatDateTime(transaction.createdDate) }}
                  </div>
                  <div class="column-subtitle">
                    Process Info
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="column-content">
                  <router-link
                    :to="{ path: `/personId/batch/${transaction.pidBatchId}/details` }"
                    class="has-text-weight-bold" style="font-size: 18px;"
                  >
                    {{ transaction.pidBatchId }}
                  </router-link>
                  <div class="column-subtitle">
                    Related Batch
                  </div>
                </div>
              </div>
              <div class="column is-narrow">
                <div class="column-content">
                  <div style="width: fit-content; margin: auto;">
                    <pid-status-info-icon
                      :header="true"
                      :processStatus="transaction.transStatus"
                    />
                    <!-- Near Match System Label needed -->
                  </div>
                  <div class="column-subtitle">
                    Status
                  </div>
                </div>
              </div>
            </div>
          </template>
        </es-profile-header>
        <div class="tabs-container no-bottom-border">
          <es-tabs :tabs="tabs" ref="tabs"></es-tabs>
        </div>
      </div>
      <router-view :transaction="transaction"/>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { mapActions } from 'vuex';
import EsException from '@/components/EsException.vue';
import EsLoader from '@/components/EsLoader.vue';
import EsProfileHeader from '@/components/EsProfileHeader.vue';
import PidStatusInfoIcon from '@/components/PidStatusInfoIcon.vue';
import BreadcrumbsManager from '@/mixins/BreadcrumbManager';
import PermissionManager from '@/mixins/PermissionManager';
import NotificationManager from '@/mixins/NotificationManager';
import EsTabs from '../../../components/EsTabs.vue';

export default {
  mixins: [
    BreadcrumbsManager,
    PermissionManager,
    NotificationManager,
  ],
  components: {
    EsException,
    EsLoader,
    EsProfileHeader,
    PidStatusInfoIcon,
    EsTabs,
  },
  props: [
    'transactionId',
  ],
  data() {
    return {
      transaction: {},
      loading: false,
      loadingError: false,
      tabs: [],
    };
  },
  created() {
    this.tabs = [
      { name: 'PITransactionInfoPerson', label: 'PERSON', ariaLabel: 'Transaction Profile Person' },
      { name: 'PITransactionInfoDetails', label: 'DETAILS', ariaLabel: 'Transaction Profile Details' },
      ...(this.hasModule('PRSID:DWNLD:DOWNLOAD') && [{
        name: 'PITransactionInfoDownload',
        label: 'DOWNLOAD',
        ariaLabel: 'Transaction Profile Download',
      }]),
    ];
    this.loadPersonTypes();
    this.loadTransaction();
  },
  mounted() {
    this.setBreadcrumbs();
  },
  methods: {
    ...mapActions('lookups', [
      'loadPersonTypes',
    ]),
    formatDateTime(value) {
      return moment(value).format('MM/DD/YYYY h:mm A');
    },
    setBreadcrumbs() {
      this.setBreadcrumb([
        { text: 'Home', to: { name: 'personId' } },
        { text: 'Processing Information ', to: {} },
      ]);
    },
    async loadTransaction() {
      try {
        this.loading = true;
        this.loadingError = false;
        const res = await axios.get(`personid/transactions/${this.transactionId}`);
        this.transaction = res.data;
      } catch (error) {
        this.apiMsg = `${error.response.status === 500
          ? 'Network Error'
          : error.response.data.message}`;
        this.showNotification('danger', [this.apiMsg]);
        this.loadingError = true;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="sass" scoped>
  .header-title
    color: #000 !important
    font-weight: 700 !important
  .header-subtitle
    color: #6c757d
  .margin-bottom
    margin-bottom: 1rem
  .max-width
    max-width: 20ch
  .progress-bar
    height: 5px
    width: 75px
    margin-bottom: 3px
    margin-left: 1rem
</style>
